import React from "react";

export interface WrapAmountLabelProps {
  amountToDisplay: string;
  visible: boolean;
}

export const WrapAmountLabel: React.FC<WrapAmountLabelProps> = props => {
  if (!props.visible) {
    return null;
  }
  return (
    <div className="amount-label-section">
      <div className={"amount-label"} data-sentry-mask="true">
        {props.amountToDisplay}
      </div>
    </div>
  );
};
